"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const log_1 = require("./log");
const renderComponent = (props) => {
    const { render, children, component } = props, rest = __rest(props, ["render", "children", "component"]);
    let rendered = null;
    if (component) {
        rendered = react_1.default.createElement(component, Object.assign({}, rest), children);
    }
    if (render) {
        rendered = render(Object.assign(Object.assign({}, rest), { children }));
    }
    if (typeof children === 'function') {
        rendered = children(rest);
    }
    else if (children) {
        rendered = children;
    }
    else {
        log_1.logError('must specify either a render prop, a render function as children, or a component prop.');
    }
    return rendered;
};
exports.renderComponent = renderComponent;
//# sourceMappingURL=renderComponent.js.map